import { Component, OnInit, OnDestroy } from '@angular/core';
import { LanguageService } from 'src/app/core/language.service';
import { SeoService } from 'src/app/core/seo.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit, OnDestroy {
  constructor(public lang: LanguageService, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.setMeta({
      title: this.lang.isArabic ? 'الصفحة غير موجودة' : 'Page Not Found',
      description: this.lang.isArabic
        ? 'عذرًا، الصفحة التي تبحث عنها غير موجودة.'
        : 'Sorry, the page you are looking for could not be found.'
    });
    // Don't let search engines index 404s.
    this.seo.setRobots('noindex, follow');
  }

  ngOnDestroy(): void {
    // Restore default indexing for the next route.
    this.seo.setRobots('index, follow');
  }
}
